export const I18N_FEATURE_NAMESPACE = 'product-barcode-scanner.feature';
